// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_wrapperChat__OPDGr {
  flex: 1 1;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}
.style_wrapperChat__OPDGr .style_btnBottom__X8AhG {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  width: 42px;
  border-radius: 36px;
  bottom: 12px;
  right: 128px;
  border: none;
  background-color: #eaedef, 0.4;
}
.style_wrapperChat__OPDGr .style_btnBottom__X8AhG:hover {
  background-color: #eaedef;
}
.style_wrapperChat__OPDGr .style_btnBottom__X8AhG .style_counterBtn__r41RQ {
  position: absolute;
  padding: 1px 6px;
  font-size: 0.675rem;
  border-radius: 20px;
  width: fit-content;
  color: #ffffff;
  background-color: #5f8fdf;
  transition: all 0.2;
  top: -4px;
  right: -4px;
}
@media (max-width: 1380px) {
  .style_wrapperChat__OPDGr .style_btnBottom__X8AhG {
    right: 28px;
  }
}
@media (max-width: 556px) {
  .style_wrapperChat__OPDGr .style_btnBottom__X8AhG {
    right: 24px;
    bottom: 68px;
  }
}

.style_chatConversation__oSH8\\+ {
  flex: 1 1;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}
@media (max-width: 991.98px) {
  .style_chatConversation__oSH8\\+ {
    height: calc(100vh - 219px);
    width: 100%;
  }
}
.style_chatConversation__oSH8\\+ ul {
  padding-left: 0;
  margin: auto;
  list-style: none;
  width: calc(100% - 25vw);
}
@media (max-width: 556px) {
  .style_chatConversation__oSH8\\+ ul {
    width: auto;
    margin: 0 20px;
  }
}
.style_chatConversation__oSH8\\+ ul li {
  display: flex;
  width: 100%;
}
.style_chatConversation__oSH8\\+ ul li.style_right__er4Cq {
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/components/Dialog/DialogList/Rows/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AADF;AAGE;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AADJ;AAGI;EACE,yBCnBQ;ADkBd;AAII;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cClCE;EDmCF,yBC5BS;ED6BT,mBAAA;EACA,SAAA;EACA,WAAA;AAFN;AAKI;EA/BF;IAgCI,WAAA;EAFJ;AACF;AAII;EAnCF;IAoCI,WAAA;IACA,YAAA;EADJ;AACF;;AAKA;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAFF;AAIE;EARF;IASI,2BAAA;IACA,WAAA;EADF;AACF;AAGE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;AADJ;AAGI;EANF;IAOI,WAAA;IACA,cAAA;EAAJ;AACF;AAEI;EACE,aAAA;EACA,WAAA;AAAN;AAEM;EACE,yBAAA;AAAR","sourcesContent":["@import '../../../../variables.scss';\n\n.wrapperChat {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n\n  .btnBottom {\n    cursor: pointer;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 42px;\n    width: 42px;\n    border-radius: 36px;\n    bottom: 12px;\n    right: 128px;\n    border: none;\n    background-color: ($gray-active, 0.4);\n\n    &:hover {\n      background-color: $gray-active;\n    }\n\n    .counterBtn {\n      position: absolute;\n      padding: 1px 6px;\n      font-size: 0.675rem;\n      border-radius: 20px;\n      width: fit-content;\n      color: $white;\n      background-color: $active-color;\n      transition: all 0.2;\n      top: -4px;\n      right: -4px;\n    }\n\n    @media (max-width: 1380px) {\n      right: 28px;\n    }\n\n    @media (max-width: 556px) {\n      right: 24px;\n      bottom: 68px;\n    }\n  }\n}\n\n.chatConversation {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n\n  @media (max-width: 991.98px) {\n    height: calc(100vh - 219px);\n    width: 100%;\n  }\n\n  ul {\n    padding-left: 0;\n    margin: auto;\n    list-style: none;\n    width: calc(100% - 25vw);\n\n    @media (max-width: 556px) {\n      width: auto;\n      margin: 0 20px;\n    }\n\n    li {\n      display: flex;\n      width: 100%;\n\n      &.right {\n        justify-content: flex-end;\n      }\n    }\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperChat": `style_wrapperChat__OPDGr`,
	"btnBottom": `style_btnBottom__X8AhG`,
	"counterBtn": `style_counterBtn__r41RQ`,
	"chatConversation": `style_chatConversation__oSH8+`,
	"right": `style_right__er4Cq`
};
export default ___CSS_LOADER_EXPORT___;
